// ---- Action types ----
export const CHANGE_ACTIVE_TS_EXPERT = "CH_TS_EXPERT";
export const CHANGE_ACTIVE_ITEM_LIVELIST = "CH_LIVELIST";
export const CHANGE_ACTIVE_ITEM_INVENTORY = "CH_INVENTORY";
export const CHANGE_ACTIVE_ITEM_TOPOLOGY = "CH_TOPOLOGY";
export const CHANGE_ACTIVE_ITEM_TRAFFIC = "CH_TRAFFIC";
export const CHANGE_ACTIVE_ITEM_LOG = "CH_LOG";
export const CHANGE_ACTIVE_ITEM_CONFIG = "CH_CONFIG";
export const SOLVE_PROBLEM = "SOLVE_PROBLEM";